import Vue from "vue";
import transactionsService from "@/services/transactions.service";

export const transactions = {
  namespaced: true,
  state: {
    transactions: [],
    transactionsTotal: 0,
    transaction: {},
    isTransactionDetailDrawerOpen: false,
    isSubscriptionEditorDrawerOpen: false,
    updateRequired: false
  },
  getters: {},
  actions: {
    async getTransactions({ commit }, payload) {
      try {
        const transaction = await transactionsService.getTransactions(payload);

        commit("setTransactions", transaction);
      } catch (error) {
        Vue.noty.error("Error getting transactions");
      }
    },
    async getTransaction({ commit }, payload) {
      try {
        const transaction = await transactionsService.getTransaction(payload);

        commit("setTransaction", {});
        commit("setTransaction", transaction);
      } catch (error) {
        Vue.noty.error("Error getting transaction");
      }
    },
    async updateSubscription({ commit }, payload) {
      try {
        const {
          amount,
          currency,
          gateway_id,
          subscription_id,
          gateway_currency_id,
          next_payment_date,
          current_payment_date,
          payment_object,
          person_object,
          organization_id
        } = payload;

        const { success } = (
          await this.$axios.post(
            `/o/${organization_id}/organization/donations/update_sub`,
            {
              gateway_id,
              subscription_id,
              amount,
              currency,
              gateway_currency_id,
              next_payment_date,
              current_payment_date,
              payment_object,
              person_object,
              organization_id
            }
          )
        ).data;

        if (!success) throw new Error(`Something went wrong!`);

        commit("setUpdateRequired", true);
        commit("setSubscriptionEditorDrawer", false);
        commit("setTransactionDetailsDrawer", false);

        Vue.noty.success(this.i18n.t("subscriptions.edit.success"));
      } catch (error) {
        throw error;
      }
    },
    async openTransactionDrawer({ commit, dispatch }, payload) {
      await dispatch("getTransaction", payload);
      commit("setTransactionDetailsDrawer", true);
    },
    /* Pendings for action view */
    async getTransactionByIdentifier({ commit }, payload) {
      try {
        const transaction = await transactionsService.getTransactionByIdentifier(
          payload
        );

        commit("setTransaction", {});
        commit("setTransaction", transaction);
      } catch (error) {
        throw error;
      }
    },
    async fixFailedTransaction({ commit, dispatch }, payload) {
      try {
        const data = transactionsService.fixFailedTransaction(payload);

        if (!data.success) throw new Error("Cannot update transaction");

        commit("setUpdateRequired", true);
        Vue.noty.success(this.i18n.t("profile.profile.success"));
      } catch (error) {
        throw error;
      }
    }
  },
  mutations: {
    setTransactions(vuexState, payload) {
      vuexState.transactions = payload.data;
      vuexState.transactionsTotal = payload.total;
    },
    setTransaction(vuexState, payload) {
      vuexState.transaction = payload;
    },
    setTransactionDetailsDrawer(vuexState, payload) {
      vuexState.isTransactionDetailDrawerOpen = payload;
    },
    setSubscriptionEditorDrawer(vuexState, payload) {
      vuexState.isSubscriptionEditorDrawerOpen = payload;
    },
    setUpdateRequired(vuexState, payload) {
      vuexState.updateRequired = payload;
    }
  }
};
